import Vue from 'vue';
import moment from "moment/moment";

const filters = [
    Vue.filter('day', function (value) {
            return moment(value)
                .format('DD/MM/YY')
    }),
    Vue.filter('month', function (value) {
        return moment(value).format('MM') + " - '" + moment(value).format('YY')
    }),
    Vue.filter('quarter', function (value) {
        return "Q" +
            moment(value).quarter() +
            " '" +
            moment(value).format('YY')
    }),
    Vue.filter('year', function (value) {
        return moment(value).year()
    }),
    // Vue.filter('formatDate', function (value) {
    //     if (value) {
    //         return moment(String(value)).format('DD-MM-YYYY HH:mm')
    //     }
    // }),
    // Vue.filter('formatShortDate', function (value) {
    //     if (value) {
    //         return moment(String(value)).format('DD-MM-YYYY')
    //     }
    // }),
    // Vue.filter('formatCurrency', function (value) {
    //     if (value) {
    //         let val = (value / 1).toFixed(2).replace('.', ',')
    //         return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    //     }
    // })
]

export default filters
//
// fullArray.forEach((dateArray, index) => {
//     dateArray.forEach((date, idx) => {
//
//         if (state.dataFilter.groupBy == 'day') {
//             fullArray[index][idx] = moment(date,{ trim: false }).format('DD/MM/YY')
//         }
//         if (state.dataFilter.groupBy == 'quarter') {
//             fullArray[index][idx] = "Q" +moment(date,{ trim: false }).quarter() + " '" + moment(date,{ trim: false }).format('YY')
//         }
//         if (state.dataFilter.groupBy == 'month') {
//             fullArray[index][idx] = moment(date,{ trim: false }).format('MM') + " - '" + moment(date,{ trim: false }).format('YY')
//         }
//         if (state.dataFilter.groupBy == 'year') {
//             fullArray[index][idx] = moment(date,{ trim: false }).year()
//         }
//     })
// fullArray[index] = _.uniq(dateArray)
// })
